// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserModal .Field .dropdown-toggle:after {
  display: none;
}
.UserModal .Modal-Body > .LoadingBlur {
  background-color: #fff;
}
.UserModal .Modal-Body .UserModal-Profile {
  margin-bottom: 2rem;
}
.UserModal .Modal-Body .UserModal-Profile > .col {
  display: flex;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Avatar {
  position: relative;
  margin-right: 1rem;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Avatar .ImageInput {
  width: 8.3rem;
  height: 8.3rem;
  border: 1px solid var(--bs-primary);
  border-radius: 50%;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Avatar .ImageInput .ImageInput-Display {
  width: calc(100% - 1rem);
  height: calc(100% - 1rem);
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Avatar .ImageInput .ImageInput-Display,
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Avatar .ImageInput .ImageInput-Display .ImageInput-Button {
  border-radius: 50%;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Avatar .ImageInput .ImageInput-Display {
  font-size: 2rem;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Info {
  padding-left: 1rem;
  border-left: 1px solid var(--bs-primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Info ul {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 0.25rem;
  height: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Info ul li {
  display: flex;
  gap: 0.5rem;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Info ul li.UserModal-Info-Name {
  flex-direction: column;
  gap: 0;
  font-size: 1.25rem;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Info ul li.UserModal-Info-Name strong {
  font-size: 1.5rem;
}
.UserModal .Modal-Body .UserModal-Profile > .col .UserModal-Info ul li.UserModal-Info-License {
  font-size: 1.25rem;
}
.UserModal .Modal-Body .UserModal-Title {
  margin-bottom: 1rem;
}
.UserModal .Modal-Body .UserModal-Title h3 {
  display: flex;
  gap: 0.5rem;
  text-transform: uppercase;
}
.UserModal .Modal-Body .UserModal-Title {
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--bs-primary);
  height: 3.5rem;
}
.UserModal .Modal-Body .UserModal-Tabs .list-group {
  --bs-list-group-bg: #f6f7f9;
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item {
  display: flex;
  justify-content: center;
  gap: 0.25rem;
  color: var(--bs-primary);
  font-weight: 600;
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item:has(.sv-warning) {
  color: var(--bs-danger) !important;
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item.active:has(+ .list-group-item), .UserModal .Modal-Body .UserModal-Tabs .list-group-item:has(+ .list-group-item) {
  border-right-color: transparent;
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item + .list-group-item,
.UserModal .Modal-Body .UserModal-Tabs .list-group-item + .list-group-item.active {
  border-left-color: transparent;
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item.active {
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
  color: var(--bs-primary);
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item.active:hover {
  background-color: var(--bs-list-group-action-hover-bg);
}
.UserModal .Modal-Body .UserModal-Tabs .list-group-item.active:after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: var(--bs-primary);
  content: "";
}
.UserModal .Modal-Body .UserModal-Content {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.UserModal .Modal-Body .UserModal-Content .UserModal-Content-Profile .ProfileForm-HireDateWarning[data-feedback]:after {
  color: var(--bs-red);
  white-space: nowrap;
}
.UserModal .Modal-Body .UserModal-Content .UserModal-Content-Profile .ProfileForm-LongTrip {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 1rem;
}
.UserModal .Modal-Body .UserModal-Content .UserModal-Content-Profile .ProfileForm-LongTrip span {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  color: #666666;
  text-transform: uppercase;
}
.UserModal .Modal-Body .UserModal-Content .UserModal-Content-Profile .ProfileForm-LongTrip span input {
  margin-bottom: 0.3rem;
}
.UserModal .Modal-Body .UserModal-Content .UserModal-Content-Licenses .LicenseForm-Add {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}
.UserModal .Modal-Body .UserModal-Content .UserModal-Content-Licenses .Field:has(button) {
  display: flex;
  gap: var(--bs-gutter-x);
}
.UserModal .Modal-Body .UserModal-Footer button {
  width: 100%;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/UserModal/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AAGI;EACE,sBAAA;AADN;AAGI;EACE,mBAAA;AADN;AAEM;EACE,aAAA;AAAR;AACQ;EACE,kBAAA;EACA,kBAAA;AACV;AAAU;EACE,aAAA;EACA,cAAA;EACA,mCAAA;EACA,kBAAA;AAEZ;AADY;EACE,wBAAA;EACA,yBAAA;AAGd;AAFc;;EAEE,kBAAA;AAIhB;AATY;EAOE,eAAA;AAKd;AADQ;EACE,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAGV;AAFU;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAIZ;AAHY;EACE,aAAA;EACA,WAAA;AAKd;AAJc;EACE,sBAAA;EACA,MAAA;EACA,kBAAA;AAMhB;AALgB;EACE,iBAAA;AAOlB;AAJc;EACE,kBAAA;AAMhB;AACI;EACE,mBAAA;AACN;AAAM;EACE,aAAA;EACA,WAAA;EACA,yBAAA;AAER;AAPI;EAOE,iBAAA;EACA,0CAAA;EACA,cAAA;AAGN;AAAM;EACE,2BAAA;AAER;AACM;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;AACR;AAAQ;EACE,kCAAA;AAEV;AAAQ;EAEE,+BAAA;AACV;AACQ;;EAEE,8BAAA;AACV;AACQ;EACE,yCAAA;EACA,iFAAA;EACA,wBAAA;AACV;AAAU;EACE,sDAAA;AAEZ;AAAU;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;EACA,WAAA;AAEZ;AAGI;EACE,iBAAA;EACA,oBAAA;AADN;AAGQ;EACE,oBAAA;EACA,mBAAA;AADV;AAGQ;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;AADV;AAEU;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AAAZ;AACY;EACE,qBAAA;AACd;AAKQ;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AAHV;AAKQ;EACE,aAAA;EACA,uBAAA;AAHV;AAQM;EACE,WAAA;EACA,yBAAA;AANR","sourcesContent":[".UserModal {\n  .Field .dropdown-toggle:after {\n    display: none;\n  }\n  .Modal-Body {\n    > .LoadingBlur {\n      background-color: #fff;\n    }\n    .UserModal-Profile {\n      margin-bottom: 2rem;\n      > .col {\n        display: flex;\n        .UserModal-Avatar {\n          position: relative;\n          margin-right: 1rem;\n          .ImageInput {\n            width: 8.3rem;\n            height: 8.3rem;\n            border: 1px solid var(--bs-primary);\n            border-radius: 50%;\n            .ImageInput-Display {\n              width: calc(100% - 1rem);\n              height: calc(100% - 1rem);\n              &,\n              .ImageInput-Button {\n                border-radius: 50%;\n              }\n              font-size: 2rem;\n            }\n          }\n        }\n        .UserModal-Info {\n          padding-left: 1rem;\n          border-left: 1px solid var(--bs-primary);\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          ul {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-around;\n            gap: 0.25rem;\n            height: 100%;\n            list-style: none;\n            padding: 0;\n            margin: 0;\n            li {\n              display: flex;\n              gap: 0.5rem;\n              &.UserModal-Info-Name {\n                flex-direction: column;\n                gap: 0;\n                font-size: 1.25rem;\n                strong {\n                  font-size: 1.5rem;\n                }\n              }\n              &.UserModal-Info-License {\n                font-size: 1.25rem;\n              }\n            }\n          }\n        }\n      }\n    }\n    .UserModal-Title {\n      margin-bottom: 1rem;\n      h3 {\n        display: flex;\n        gap: 0.5rem;\n        text-transform: uppercase;\n      }\n      padding: 0.5rem 0;\n      border-bottom: 1px solid var(--bs-primary);\n      height: 3.5rem;\n    }\n    .UserModal-Tabs {\n      .list-group {\n        --bs-list-group-bg: #f6f7f9;\n      }\n\n      .list-group-item {\n        display: flex;\n        justify-content: center;\n        gap: 0.25rem;\n        color: var(--bs-primary);\n        font-weight: 600;\n        &:has(.sv-warning) {\n          color: var(--bs-danger) !important;\n        }\n        &.active:has(+ .list-group-item),\n        &:has(+ .list-group-item) {\n          border-right-color: transparent;\n        }\n        + .list-group-item,\n        + .list-group-item.active {\n          border-left-color: transparent;\n        }\n        &.active {\n          background-color: var(--bs-list-group-bg);\n          border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n          color: var(--bs-primary);\n          &:hover {\n            background-color: var(--bs-list-group-action-hover-bg);\n          }\n          &:after {\n            display: block;\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            width: 100%;\n            height: 3px;\n            background-color: var(--bs-primary);\n            content: '';\n          }\n        }\n      }\n    }\n    .UserModal-Content {\n      padding-top: 2rem;\n      padding-bottom: 2rem;\n      .UserModal-Content-Profile {\n        .ProfileForm-HireDateWarning[data-feedback]:after {\n          color: var(--bs-red);\n          white-space: nowrap;\n        }\n        .ProfileForm-LongTrip {\n          display: flex;\n          align-items: center;\n          height: 100%;\n          gap: 1rem;\n          span {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            justify-content: center;\n            color: #666666;\n            text-transform: uppercase;\n            input {\n              margin-bottom: 0.3rem;\n            }\n          }\n        }\n      }\n      .UserModal-Content-Licenses {\n        .LicenseForm-Add {\n          display: flex;\n          justify-content: center;\n          gap: 0.5rem;\n          width: 100%;\n        }\n        .Field:has(button) {\n          display: flex;\n          gap: var(--bs-gutter-x);\n        }\n      }\n    }\n    .UserModal-Footer {\n      button {\n        width: 100%;\n        text-transform: uppercase;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
